import { render, staticRenderFns } from "./presentation2.vue?vue&type=template&id=301d7b29&scoped=true"
import script from "./presentation2.vue?vue&type=script&lang=js"
export * from "./presentation2.vue?vue&type=script&lang=js"
import style0 from "./presentation2.vue?vue&type=style&index=0&id=301d7b29&prod&lang=css"
import style1 from "./presentation2.vue?vue&type=style&index=1&id=301d7b29&prod&scoped=true&lang=css"
import style2 from "./presentation2.vue?vue&type=style&index=2&id=301d7b29&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301d7b29",
  null
  
)

export default component.exports